import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";
import { Box, Typography } from "@mui/material";

function UploadTenantLogoField({ logo, setLogo }) {
  const [logoPreview, setLogoPreview] = useState(null);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      setLogo(file);
      setLogoPreview(URL.createObjectURL(file));
    },
    [setLogo]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*",
  });

  return (
    <div>
      <Box
        {...getRootProps()}
        sx={{
          border: "2px dashed #000000",
          borderRadius: "8px",
          padding: "20px",
          textAlign: "center",
          cursor: "pointer",
          mb: 3,
          color: "#000000",
          fontWeight: "bold",
        }}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <Typography
            variant="body1"
            sx={{ color: "black", fontWeight: "bold" }}
          >
            Ziehe das Logo hierher...
          </Typography>
        ) : (
          <Typography
            variant="body1"
            sx={{ color: "black", fontWeight: "bold" }}
          >
            Hier klicken oder Logo hierherziehen
          </Typography>
        )}
      </Box>
      <Typography variant="h6" sx={{ color: "black", fontWeight: "bold" }}>
        Vorschau:
      </Typography>
      {logo ? (
        <>
          <Typography variant="body2" component="p" sx={{ mb: 2 }}>
            {logo.name}
          </Typography>
          {logoPreview && (
            <Box mt={2} sx={{ textAlign: "center" }}>
              <img
                src={logoPreview}
                alt="Logo Preview"
                style={{ maxWidth: "100%", maxHeight: 60 }}
              />
            </Box>
          )}
        </>
      ) : (
        <Typography variant="body2" component="p" sx={{ mb: 2 }}>
          Noch kein Logo ausgewählt. Bitte fügen Sie das Logo über die oben
          aufgeführte Funktion hinzu.
        </Typography>
      )}
    </div>
  );
}

UploadTenantLogoField.propTypes = {
  logo: PropTypes.object,
  setLogo: PropTypes.func,
};

export default UploadTenantLogoField;
